import {ngAsync} from 'shared/utils/ng-@decorators';
import {unRestangularize} from 'shared/utils/data-service-utils';
import type {ForeignOccurrence, PlainAvailability} from 'typings/portaro.be.types';

export default class ForeignDocumentDataService {
    public static serviceName = 'foreignDocumentDataService';

    public static readonly FOREIGN_OCCURRENCES_ROUTE = 'foreign-occurrences';
    public static readonly FOREIGN_AVAILABILITY_ROUTE = 'foreign-availability';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getDocumentOccurrences(recordId: string): Promise<ForeignOccurrence[]> {
        return this.Restangular
                   .one(ForeignDocumentDataService.FOREIGN_OCCURRENCES_ROUTE)
                   .get({record: recordId});
    }

    @ngAsync()
    @unRestangularize()
    public async getDocumentAvailability(databaseId: number, foreignRecordKindedId: number): Promise<PlainAvailability> {
        return this.Restangular
                   .one(ForeignDocumentDataService.FOREIGN_AVAILABILITY_ROUTE)
                   .get({
                       database: databaseId,
                       foreignDocument: foreignRecordKindedId
                   });
    }

}